import "../../../../../../vue@3.5.13_typescript@4.9.5/node_modules/vue/dist/vue.runtime.esm-bundler.es.js";
import useSpinner, { useSpinnerProps } from "./use-spinner.es.js";
import { createComponent } from "../../utils/private.create/create.es.js";
import { h } from "../../../../../../@vue_runtime-core@3.5.13/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.es.js";
const QSpinner = createComponent({
  name: "QSpinner",
  props: {
    ...useSpinnerProps,
    thickness: {
      type: Number,
      default: 5
    }
  },
  setup(props) {
    const { cSize, classes } = useSpinner(props);
    return () => h("svg", {
      class: classes.value + " q-spinner-mat",
      width: cSize.value,
      height: cSize.value,
      viewBox: "25 25 50 50"
    }, [
      h("circle", {
        class: "path",
        cx: "50",
        cy: "50",
        r: "20",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": props.thickness,
        "stroke-miterlimit": "10"
      })
    ]);
  }
});
export {
  QSpinner as default
};
//# sourceMappingURL=QSpinner.es.js.map
